import React from "react";
import { IoIosHeartEmpty } from "react-icons/io";
import { TiStar } from "react-icons/ti";

const imageZoomLayer =
  "absolute inset-0 z-0 bg-gray-200 bg-cover bg-center transition-transform duration-500 ease-out group-hover:scale-110";

/**
 * Marketplace product tile for grid layouts (e.g. Continental Finds).
 * Uses flex column + mt-auto so row heights align in CSS Grid while the image keeps a stable aspect ratio.
 */
const ContinentalProductCard = ({ product, className = "", onFavoriteClick }) => {
  const imageUrl = product?.images?.[0];
  const vendorName = product?.merchant?.firstName;
  const origin = product?.country;

  return (
    <article
      style={{ boxShadow: "0px 2px 12px -2px #251D1814" }}
      className={`box-border flex h-full w-full min-w-0 flex-col overflow-hidden rounded-[16px] bg-[#FDFCFC] transition-shadow duration-300 ease-out group hover:shadow-[0px_8px_24px_-4px_#251D1820] ${className}`}
    >
      <div className="relative h-[200px] w-full shrink-0 overflow-hidden bg-[#f8f8f8]">
        {imageUrl ? (
          <div
            className={imageZoomLayer}
            style={{ backgroundImage: `url('${imageUrl}')` }}
          />
        ) : (
          <div className="absolute inset-0 z-0 bg-[#ebe8e6]" />
        )}
        <div className="relative z-10 flex h-full flex-col justify-between p-2 box-border">
          <div className="flex justify-end">
            {/* span avoids nested <button> inside parent <Link> */}
            <span
              role="presentation"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onFavoriteClick?.(product);
              }}
              className="grid h-[32px] w-[32px] cursor-pointer place-content-center rounded-full bg-[#FDFCFCCC] backdrop-blur-2"
            >
              <IoIosHeartEmpty className="text-[#7E6F67]" aria-hidden />
            </span>
          </div>

          {origin?.name ? (
            <div className="mt-auto bg-[#FDFCFCCC] w-fit px-2 text-[12px] rounded-full py-[2px] backdrop-blur-sm">
              {origin?.flagUrl ? (
                <img
                  src={origin.flagUrl}
                  alt=""
                  className="mr-1 inline-block h-[10px] w-[14px] object-cover"
                />
              ) : null}
              <span className="text-[#251D18]">{origin.name}</span>
            </div>
          ) : null}
        </div>
      </div>

      <div className="flex min-h-0 flex-1 flex-col gap-y-1 p-2">
        {vendorName ? (
          <span className="text-[12px] text-[#7E6F67]">{vendorName}</span>
        ) : null}
        <span className="text-[14px] font-medium leading-snug text-[#251D18] line-clamp-2">
          {product?.name}
        </span>
        <div className="mt-auto flex items-center gap-x-1">
          <TiStar className="text-[#E2A936]" aria-hidden />
          <span className="text-[10px] text-[#7E6F67]">
            {product?.rating != null ? Number(product.rating).toFixed(1) : "—"}
          </span>
        </div>
      </div>
    </article>
  );
};

export default ContinentalProductCard;
